function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { authLoader, isAuthenticatedSelector, isAuthenticatingSelector, isInitializedSelector } from '@signal/core/auth';
import injectLoader from '../injectLoader';
/**
 * The withAuth hoc provides a way to wrap any component with authentication
 * information. It also injects the authenticate loader which automatically attempts to
 * log the user in. It then passes three props down to the wrapped component.
 * isAuthenticated {boolean} - Is the user authenticated
 * isAuthenticating {boolean} - Is an authentication request currently being made
 * isAuthInitialized {boolean} - Has an authentication request been made before.
 * After being set to true, isAuthInitialized will never be set to false.
 *
 * @param {function} mapStoreToProps - This function allows the auth props to be
 * custom formatted.
 *
 * @returns {function} - `withAuth` higher-order component
 */

export default (function () {
  var mapStoreToProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (auth) {
    return {
      auth: auth
    };
  };
  return function (WrappedComponent) {
    var AuthProvider = /*#__PURE__*/function (_React$Component) {
      _inherits(AuthProvider, _React$Component);

      var _super = _createSuper(AuthProvider);

      function AuthProvider() {
        _classCallCheck(this, AuthProvider);

        return _super.apply(this, arguments);
      }

      _createClass(AuthProvider, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
              isAuthenticated = _this$props.isAuthenticated,
              isAuthenticating = _this$props.isAuthenticating,
              isAuthInitialized = _this$props.isAuthInitialized;
          var auth = {
            isAuthenticated: isAuthenticated,
            isAuthenticating: isAuthenticating,
            isAuthInitialized: isAuthInitialized
          };
          return /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({}, this.props, mapStoreToProps(auth)));
        }
      }]);

      return AuthProvider;
    }(React.Component);

    _defineProperty(AuthProvider, "WrappedComponent", WrappedComponent);

    _defineProperty(AuthProvider, "displayName", "withAuth(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")"));

    hoistNonReactStatics(AuthProvider, WrappedComponent);
    var mapStateToProps = createStructuredSelector({
      isAuthenticated: isAuthenticatedSelector,
      isAuthenticating: isAuthenticatingSelector,
      isAuthInitialized: isInitializedSelector
    });
    return compose(injectLoader(authLoader), connect(mapStateToProps))(AuthProvider);
  };
});